import {SxProps, Theme} from '@mui/material';
import theme from 'src/theme';

/** The same column and gap TableLayout uses, so this heading sits at the distance the others do. */
export const sectionSx: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
};

export const titleSx: SxProps<Theme> = {
    [theme.breakpoints.down('lg')]: {
        m: 2,
    },
};